/* ============================================================================
   covers.js — copertele jocurilor în mărimi mici (v9 8.5-D2)
   ----------------------------------------------------------------------------
   RO: De ce (măsurătoarea lui Alex, 19 oct.): catalogul descărca 44 MB, cu coperți
       de până la 4,7 MB afișate în carduri de 48–313 px; banda de pe pagina de start
       descărca 7,36 MB (măsurat 8 aug.). Aplicația salvează coperta ORIGINALĂ de la
       BGG; BGG are aceeași copertă și în mărimi mici, pe CDN-ul lui (cost zero), dar
       adresele lor sunt semnate ⇒ le aflăm o singură dată, prin bgg-proxy (tipul
       `images`, 8.5-D1), și le ținem aici, pe dispozitiv.
       • `pick(url, fel)` — SINCRON, la randare: adresa mărimii potrivite locului
         (`list` 48 px, `thumb` ~104–200 px, `tile` grila 151×202, `banner` ~313 px,
         `wide` bannere late / detalii), după densitatea ecranului. Fără mărime
         cunoscută ⇒ adresa originală, exact ca înainte (nimic nu dispare).
       • Doar coperțile `__original` de pe cf.geekdo-images.com; orice altă adresă
         (alt site, altă variantă) rămâne neschimbată.
       • Harta pic → adrese stă în localStorage (`to-cov`): date PUBLICE de la BGG,
         ca pagina de start să aibă coperțile mici imediat, fără nicio cerere la
         pornire. Se golește la delogare (logout). Fiecare adresă e verificată
         (doar CDN-ul BGG, aceeași poză) și la citire, și la scriere.
       • Ce lipsește se completează DUPĂ pornire, în fundal: covers-fill.js, încărcat
         la cerere (TO_CHAT.ensureModule). Efectul se vede la următoarea afișare.
       Nimic din bază nu se schimbă: în catalog rămâne adresa originală (folosită la
       „imaginea mare" și la datele salvate).
   EN: picks a small BGG cover variant for each display slot; falls back to the
       original. Public BGG URLs cached in localStorage; filled lazily after start.
   ============================================================================ */
(function () {
    'use strict';
    if (window.TO_COVER) return;

    var LS = 'to-cov', MAX_AGE = 30 * 864e5, KEYS = ['xs', 'sm', 'md', 'lg'];
    var ORIG_RE = /^https:\/\/cf\.geekdo-images\.com\/[A-Za-z0-9_-]{8,64}__original\/[^?#\s"'<>]*\/pic(\d{1,12})\.(?:jpg|jpeg|png|webp|gif)$/;
    var CDN_RE = /^https:\/\/cf\.geekdo-images\.com\/[A-Za-z0-9_-]{8,64}__[a-z0-9@]{2,24}\/img\/[A-Za-z0-9_-]{8,64}={0,2}\/[A-Za-z0-9:(),_.\/-]{1,160}\/pic(\d+)\.(?:jpg|jpeg|png|webp|gif)$/;
    /* `tried`: poze cerute în sesiunea asta fără răspuns (alt CDN, BGG fără mărimi) ⇒ nu le
       mai cerem la fiecare redesenare. */
    var map = {}, missing = {}, tried = {}, timer = 0, offUntil = 0, started = false;

    function logErr(where, e) { try { if (typeof window.logError === 'function') window.logError(where, e); } catch (x) { /* noop */ } }

    /* O intrare validă: doar cheile xs / sm / md / lg, doar adrese BGG ale aceleiași poze. */
    function clean(pic, v) {
        if (!v || typeof v !== 'object') return null;
        var out = {}, n = 0;
        for (var i = 0; i < KEYS.length; i++) {
            var u = v[KEYS[i]], m = (typeof u === 'string' && u.length <= 300) ? CDN_RE.exec(u) : null;
            if (m && m[1] === String(pic)) { out[KEYS[i]] = u; n++; }
        }
        if (!n) return null;
        out.a = (typeof v.a === 'number') ? v.a : Date.now();
        return out;
    }
    function load() {
        try {
            var o = JSON.parse(localStorage.getItem(LS) || 'null');
            if (!o || o.v !== 1 || !o.m || typeof o.m !== 'object') return;
            Object.keys(o.m).forEach(function (p) { if (/^\d{1,12}$/.test(p)) { var e = clean(p, o.m[p]); if (e) map[p] = e; } });
        } catch (e) { map = {}; }
    }
    function save() {
        try { localStorage.setItem(LS, JSON.stringify({ v: 1, m: map })); } catch (e) { /* mod privat / plin: rămâne doar în memorie */ }
    }
    function picOf(u) { var m = ORIG_RE.exec(String(u || '')); return m ? m[1] : null; }

    /* Mărimea după loc și densitatea ecranului (pe A55 ~2,6; pe Windows de obicei 1–1,5). */
    function want(kind) {
        var d = window.devicePixelRatio || 1;
        if (kind === 'list') return d >= 2 ? 'sm' : 'xs';      /* 48 px: 128 / 400×300 */
        if (kind === 'thumb') return d >= 2 ? 'md' : 'sm';     /* ~104–200 px lățime */
        if (kind === 'tile') return 'md';                      /* 151×202: 500 px */
        if (kind === 'banner') return d >= 1.5 ? 'lg' : 'md';  /* ~313×116 */
        return 'lg';                                           /* bannere late, detalii: 1000 px */
    }

    function pick(url, kind) {
        var u = String(url || ''), p = picOf(u);
        if (!p) return u;
        var e = map[p];
        if ((!e || Date.now() - (e.a || 0) > MAX_AGE) && !tried[p]) { missing[p] = 1; schedule(); }
        if (!e) return u;
        for (var i = KEYS.indexOf(want(kind)); i > -1 && i < KEYS.length; i++) { if (e[KEYS[i]]) return e[KEYS[i]]; }
        return u;
    }

    /* Completarea: după pornire (nu concurează cu încărcarea aplicației), în fundal. */
    function schedule(ms) {
        if (timer || Date.now() < offUntil) return;
        timer = setTimeout(function () { timer = 0; fill(); }, ms || (started ? 1500 : 4000));
    }
    function fill() {
        try {
            if (typeof isDemoMode === 'function' && isDemoMode()) return;
            if (!window.TO_CHAT || !TO_CHAT.ensureModule || typeof sb === 'undefined' || !sb) return;
            started = true;
            /* toate coperțile din catalog care lipsesc, nu doar cele văzute până acum */
            try {
                var cat = (typeof state !== 'undefined' && state && state.catalog) || {};
                Object.keys(cat).forEach(function (n) { var p = picOf(cat[n] && cat[n].imageUrl); if (p && !tried[p] && (!map[p] || Date.now() - (map[p].a || 0) > MAX_AGE)) missing[p] = 1; });
            } catch (e) { /* noop */ }
            var ids = Object.keys(missing);
            if (!ids.length) return;
            TO_CHAT.ensureModule('covers-fill.js', 'TO_COVER_FILL').then(function (M) {
                return M.run(ids, {
                    put: put,
                    done: function (id) { delete missing[id]; tried[id] = 1; },
                    off: function (ms) { offUntil = Date.now() + ms; },
                    again: function (ms) { schedule(ms); }
                });
            }).catch(function () { offUntil = Date.now() + 5 * 60000; });
        } catch (e) { logErr('TO_COVER.fill', e); }
    }
    function put(items) {
        var n = 0;
        Object.keys(items || {}).forEach(function (p) {
            if (!/^\d{1,12}$/.test(p)) return;
            var e = clean(p, Object.assign({}, items[p], { a: Date.now() }));
            if (e) { map[p] = e; delete missing[p]; n++; }
        });
        if (n) save();
        return n;
    }
    function clear() {
        map = {}; missing = {}; tried = {};
        try { localStorage.removeItem(LS); } catch (e) { /* noop */ }
    }

    load();
    window.TO_COVER = { pick: pick, clear: clear, picOf: picOf, _map: function () { return map; } };
})();
